import { render, staticRenderFns } from "./Qualification.vue?vue&type=template&id=cc2dd49e&scoped=true"
import script from "./Qualification.vue?vue&type=script&lang=ts"
export * from "./Qualification.vue?vue&type=script&lang=ts"
import style0 from "./Qualification.vue?vue&type=style&index=0&id=cc2dd49e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2dd49e",
  null
  
)

export default component.exports